/* eslint-disable @typescript-eslint/indent */
import { createApi } from '@reduxjs/toolkit/query/react';
import { TServerResponse } from 'app/types/server-response';
import { authAPIBase } from 'app/utilities/env';
import getBaseQueryWithLogout from 'app/utilities/getBaseQuery';
import { TUser } from 'features/auth/types';
import { Terminal } from 'features/routing/types/terminals';

import {
  ProfileImageUpdateDTO,
  UpdateProfileDTO,
  UpdateTopDestinationsDTO,
} from '../types/profile';

const baseQueryWithLogout = getBaseQueryWithLogout(`${authAPIBase}/user`);

export const profileApiSlice = createApi({
  reducerPath: 'profileApi',
  baseQuery: baseQueryWithLogout,
  endpoints: (build) => ({
    updateProfileImage: build.mutation<TUser, ProfileImageUpdateDTO>({
      query: ({ image, userId }) => ({
        url: `/profile-image/${userId}`,
        method: 'POST',
        body: (() => {
          const fd = new FormData();
          fd.append('profileImage', image);
          return fd;
        })(),
      }),
      transformResponse: (response: TServerResponse<TUser>) => response.data,
    }),

    updateProfile: build.mutation<TUser, UpdateProfileDTO>({
      query: (body) => ({
        url: '/update',
        method: 'POST',
        body,
      }),
      transformResponse: (response: TServerResponse<TUser>) => response.data,
    }),

    updateTopDestinations: build.mutation<Terminal[], UpdateTopDestinationsDTO>(
      {
        query: ({ topDestinations, userId }) => ({
          url: `/top-destinations/${userId}`,
          method: 'POST',
          body: { topDestinations },
        }),
        transformResponse: (response: TServerResponse<Terminal[]>) =>
          response.data,
      }
    ),
  }),
});

export const {
  useUpdateProfileImageMutation,
  useUpdateProfileMutation,
  useUpdateTopDestinationsMutation,
} = profileApiSlice;
